import { render, staticRenderFns } from "./income-by-sale.vue?vue&type=template&id=2cfa1412&"
import script from "./income-by-sale.vue?vue&type=script&lang=js&"
export * from "./income-by-sale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports